export default __webpack_public_path__ + "static/media/7.3497ab52.png";